import React from "react"
import { useSelector } from "react-redux"
import { AppLayout, NavigationItemObject, navigationItems } from "app/navigationItems"
import { getCurrentUser } from "app/redux/currentUser/currentUser.selectors"
import { arraysIntersect } from "utils"
import AvatarIcon from "components/Icons/Avatar.icon"
import { Roles } from "app/models/user"

export function useNavigationItems(layout?: AppLayout) {
  const currentUser = useSelector(getCurrentUser)
  const navItems: NavigationItemObject[] =
    layout === "mobile"
      ? [
          ...navigationItems,
          {
            icon: <AvatarIcon />,
            name: "navigationItem.profile",
            to: `/employees/${currentUser && currentUser.id}/employee-details`,
            allowedRoles: [Roles.Planner, Roles.HROfficer, Roles.User],
            visible: ["mobile"],
          },
        ]
      : navigationItems

  return navItems.filter(
    item => arraysIntersect(item.allowedRoles, currentUser?.roles || []) && (!layout || item.visible.includes(layout)),
  )
}
